<template>
    <table class="table table-condensed">
		<template v-if="previewNotAvailable">
			<tr>
				<td>
					<div class="alert alert-warning">
						<p :class="{'mb-0': !errors.length}">{{ $t('no-preview-available-for-data-element') }}</p>
						<ul v-if="errors.length">
							<li v-for="(error, i) in errors" :key="i">{{ error }}</li>
						</ul>
					</div>
				</td>
			</tr>
		</template>
		<template v-else>
			<thead>
				<tr>
					<th></th>
					<template v-if="captions">
						<th v-for="caption in captions" :key="caption">
							{{caption}}
						</th>
					</template>
				</tr>
			</thead>
			<tbody>
				<tr v-for="user in users" :key="user.id">
					<td>{{ user.displayName }}</td>
					<template v-if="previewData">
						<td v-if="(typeof previewData[user.id] == 'string')">
							{{ previewData[user.id] }}
						</td>
						<template v-else>
							<td v-for="key in captions" :key="key">
								<template v-if="key in previewData[user.id]">
									{{ handleDate(previewData[user.id][key]) }} 
								</template>
								<template v-else>
									0
								</template>
							</td>
						</template>
					</template>
				</tr>
			</tbody>
		</template>
    </table>
</template>

<script>
export default {
	name: 'DataElementPreview',
	props: ['dataelement', 'dataelementfilters', 'selectedReturnProperties'],
	data() {
		return {
			users: [],
			previewData: null,
			captions: [],
			previewNotAvailable: false,
			errors: []
		};
	},
	watch: {

	},
	mounted() {
		this.errors = this.dataelementfilters.getErrors();
		if(!this.errors.length) {
			if(this.dataelement.data.datasource == 'teachergrades' || this.dataelement.data.datasource == 'treatmentsessionteacherfeedback'){
				this.$store.commit("showBlockingSpinner");
				this.$users.getTeachers.call(this).then((teachers) => {
					this.users = teachers;
					this.getPreviewData();
				});
			} else {
				this.$store.commit("showBlockingSpinner");
				this.$users.getStudents.call(this).then((students) => {
					this.users = students;
					this.getPreviewData();
				});
			}
		} else {
			this.previewNotAvailable = true;
		}
	},
	methods: {
		getPreviewData() {

			this.$cfetch(`${this.$settings.APIBaseURL}/reporting/alldata/datasourcepreview`, {
            	method: "post",
            	data: this.dataelement.data
            })
            .then(json => {

            	this.$store.commit("hideBlockingSpinner");

            	const _data = json.results;

				const firstData = _data[Object.keys(_data)[0]];

				// fill in gaps in data using student list
				var zeroDataObj = {};
				for(let property in firstData) {
					zeroDataObj[property] = '0';
				}

				for(const user of this.users) {
					if(!(user.id in _data)) {
						if(typeof firstData == 'string') {
							_data[user.id] = '0';
						} else {
							_data[user.id] = zeroDataObj;
						}
					}
					if(this.dataelement.data.datasource == 'competencytestpass'){
						if(typeof _data[user.id] == 'object') {
							for(let property in firstData) {
								if(_data[user.id][property] > 0){
									_data[user.id][property] = this.$datetime.timestampToDate(_data[user.id][property]);
								} else {
									_data[user.id][property] = '0';
								}
							}
						} else {
							if(_data[user.id] > 0){
								_data[user.id] = this.$datetime.timestampToDate(_data[user.id]);
							} else {
								_data[user.id] = '0';
							}
						}
					}
				};

				this.previewData = _data;

				this.captions = [];
				this.selectedReturnProperties.forEach(caption => {
					this.captions.push(caption.split("=")[0]);
				});

            }).catch(error => {
            	this.$store.commit("hideBlockingSpinner");
            	this.previewNotAvailable = true;
                this.$log.error.call(this, error);
            });

		},
        handleDate(input){
           return input < 100000 ? (input > 0 ? input : '0' ) : '1';
        }
	}
};
</script>
